import * as React from "react";
const SmallUpload = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21}
      height={20}
      fill="none"
      {...props}
    >
      <path
        stroke="#fff"
        strokeWidth={1.5}
        d="M3.08 8.334c-.053.38-.08.77-.08 1.167 0 4.418 3.358 8 7.5 8 4.142 0 7.5-3.582 7.5-8 0-.397-.027-.786-.08-1.167M10.5 2.5v8.333m0-8.333L8 5m2.5-2.5L13 5"
      />
    </svg>
  );
};
export { SmallUpload };
